import { Flex, Pill, PillWrapper } from "@theorgchartdev/storybook";

type InputValuePillsProps = {
  values: string | string[] | null | undefined;
  key?: string;
  onChange: Function;
  onRemoveItem?: Function;
  getLabel?: (value: string) => string;
  inputProps?: any;
};

export const InputValuePills = ({
  values,
  key,
  onChange,
  onRemoveItem,
  getLabel,
  inputProps
}: InputValuePillsProps) => {
  if (values === null || values === undefined || (Array.isArray(values) && values.length === 0))
    return null;

  const inputSize = inputProps?.size || "medium";

  const valueArray = Array.isArray(values) ? values : [values];

  if (valueArray.length > 1) {
    return (
      <Flex gap="4px" wrap="wrap" style={{ maxWidth: "100%" }}>
        {valueArray.map((val, index) => (
          <PillWrapper key={`${key}-pill-wrapper-${index}`}>
            <Pill
              key={`${key}-pill-${index}`}
              className="oc-topbox-pill"
              size={inputSize === "small" ? "compact" : "regular"}
              onRemove={e => {
                e.stopPropagation();

                const newValues = [...valueArray];
                newValues.splice(index, 1);

                if (onRemoveItem) {
                  onRemoveItem(val);
                }

                onChange(newValues);
              }}
              disabled={inputProps?.disabled}
              label={getLabel ? getLabel(val) : val}
            />
          </PillWrapper>
        ))}
      </Flex>
    );
  }

  return (
    <PillWrapper>
      <Pill
        className="oc-topbox-pill"
        size={inputSize === "small" ? "compact" : "regular"}
        onRemove={e => {
          e.stopPropagation();

          if (onRemoveItem) {
            onRemoveItem(valueArray[0]);
          }

          onChange([]);
        }}
        disabled={inputProps?.disabled}
        label={getLabel ? getLabel(valueArray[0]) : valueArray[0]}
      />
    </PillWrapper>
  );
};
